import { Component, ViewEncapsulation } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  standalone: true,
  selector: 'mark-cdr-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  imports: [MatProgressSpinnerModule],
  host: {
    class: 'mark-cdr-loader',
  },
  encapsulation: ViewEncapsulation.None,
})
export class LoaderComponent {}
